import { render, staticRenderFns } from "./AccessInvitationModal.vue?vue&type=template&id=d1d45a42&scoped=true&lang=pug&"
import script from "./AccessInvitationModal.vue?vue&type=script&lang=ts&"
export * from "./AccessInvitationModal.vue?vue&type=script&lang=ts&"
import style0 from "./AccessInvitationModal.vue?vue&type=style&index=0&id=d1d45a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d45a42",
  null
  
)

export default component.exports